import { Link } from "gatsby"
import React from "react"
import Card from "react-bootstrap/Card"
import styled from "styled-components"
import { BackgroundImg } from "../styles/global"

const BlogPostCard = props => {
  const { title, slug } = props.spotlight
  const { mainImage, subtitle } = props

  return (
    <Link to={`/spotlight/${slug.current}`} className="text-decoration-none">
      <StyledCard className="mb-3">
        {mainImage && <BackgroundImg fluid={mainImage.asset.fluid} />}
        <Text>
          <CardHeading className="text-white">{title}</CardHeading>
          {subtitle && (
            <CardSubtitle className="text-white">{subtitle}</CardSubtitle>
          )}
          <br />
          <CardText className="text-white">
            <small className="text-decoration-underline">
              View now <span className="ml-1">→</span>
            </small>
          </CardText>
        </Text>
      </StyledCard>
    </Link>
  )
}

export default BlogPostCard

const StyledCard = styled(Card).attrs({ className: "position-relative" })`
  overflow: hidden;
  max-height: 67vh;
`

const Text = styled.div`
  width: 95%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  a {
    color: white;
  }
`

const CardHeading = styled.h2.attrs({
  className: "",
})``

const CardSubtitle = styled.div.attrs({
  className: "",
})``

const CardText = styled.div.attrs({
  className: "",
})``

const Series = styled.div.attrs({
  className: "overline text-white ",
})``
